import React from 'react'

export default function LoadingComponent({loadingText}) {
  return (
    <div 
      style={{position:'fixed',top:0,left:0, height:'100vh', width:'100vw',zIndex:'999', backgroundColor:'rgb(14,14,14,0.6)',color:'forestgreen'}}
      className='container-fluid rounded d-flex flex-column justify-content-center align-items-center m-auto'>
        <div className="spinner-border fw-bolder" style={{width: '4rem', height: '4rem',fontWeight:'900'}} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      
        <h6 className="">{loadingText? loadingText:'Please wait ....'}</h6>
      </div>
  )
}
